import { InputNumber } from "primereact/inputnumber";

const AIEduInputNumber = (props) => {
    const { title, titleStyle, noFloat } = props;

    return (
        <div>
            <span
                className={noFloat ? "" : "mt-3"}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                }}
            >
                <label htmlFor={title} className={titleStyle}>
                    {title}
                </label>
                <InputNumber {...props} />
            </span>
        </div>
    );
};

export default AIEduInputNumber;
